import { useFlags } from 'launchdarkly-react-client-sdk';
import { useTranslation } from 'react-i18next';
import { useSnapshot } from 'valtio';
import { Presence } from 'generated/event.types';
import { commonFields } from 'modules/events//basics/constants/commonFormFields.constants';
import eventState from 'modules/events//states/events.states';
import { EventStateType } from 'modules/events/basics/types/events.types';

const useAttendanceProofGroupConfig = () => {
  const { t } = useTranslation();
  const flags = useFlags();
  const snap = useSnapshot(eventState) as EventStateType;
  const { presence, data } = snap.createEvent;
  const isVirtual = presence === Presence.online;
  const isSignatureEnabled = !!flags.eventsCweb2287GatherParticipantSignatureForPhysicalAttendance;
  const hasExistingParticipants = (data?.participants?.length ?? 0) > 0;
  const wasSignatureCollectionOff = data?.signatureCollection !== true;

  return {
    qrCodeRegistration: {
      label: t('attendanceProofGroup_qrCode_label'),
      name: commonFields.qrCodeRegistration,
      checked: isVirtual ? false : (data?.qrCodeRegistration ?? true),
      disabled: isVirtual,
      tooltip: isVirtual
        ? t('attendanceProofGroup_qrCode_tooltip_virtual')
        : t('attendanceProofGroup_qrCode_tooltip'),
    },
    signatureCollection: {
      label: t('attendanceProofGroup_signature_label'),
      name: commonFields.signatureCollection,
      checked: data?.signatureCollection ?? false,
      disabled: isVirtual,
      hidden: !isSignatureEnabled,
      tooltip: isVirtual
        ? t('attendanceProofGroup_signature_tooltip_virtual')
        : t('attendanceProofGroup_signature_tooltip'),
      showRetroactiveWarning: hasExistingParticipants && wasSignatureCollectionOff,
    },
  };
};

export default useAttendanceProofGroupConfig;
